module.exports = __webpack_public_path__ + "img/cover_photo.8402168f.jpg";